/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2022 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React from 'react';
import {useTranslation} from "react-i18next";

const ListingTop = (props) => {

    const { t, i18n } = useTranslation();

    return (
        <div className='listing-top'>
            <div className='listing-top__row'>
                <div className='listing-top__sortBy'>
                    <div className='sortBy'>
                        <div className='sortBy__label'>{t('parts.sortBy')}</div>
                        <select className='sortBy__select' onChange={ (e) => props.onSort(e.target.value) } value={props.value}>
                            <option value='date-asc'>{t('parts.dateadded')} {t('parts.ASC')}</option>
                            <option value='date-desc'>{t('parts.dateadded')} {t('parts.DESC')}</option>
                            <option value='price-asc'>{t('parts.price')} {t('parts.ASC')}</option>
                            <option value='price-desc'>{t('parts.price')} {t('parts.DESC')}</option>
                            <option value='image'>{t('parts.HasImages')}</option>
                        </select>
                    </div>
                </div>
                <div className='listing-top__partResults'>
                    {t('parts.results', {items: props.count})}
                </div>
            </div>
        </div>
    );
};

ListingTop.defaultProps = {
    count: '-',
    sortValue: '',
};

export default ListingTop;

